import get from 'lodash/get';

export const selectRedirectPathname = (state) => get(state, 'global.redirectPathname', '');
export const selectRedirectSearch = (state) => get(state, 'global.redirectSearch', '');
export const selectRedirectSaveHistory = (state) => get(state, 'global.redirectSaveHistory', false);
export const selectHasPendingChanges = (state) => get(state, 'global.redirectHasPendingChanges', false);
export const selectTabToggleValue = (state, tab, field) => get(state, `global.tabs.${tab}.${field}.expanded`, false);
export const selectLastUrlVisitedInsideWs = (state) => get(state, 'global.lastUrlVisitedInsideWs', '/workspaces');
export const selectWorkspaceSelected = (state) => get(state, 'global.workspaceSelected', '');
